import { ICartItem } from "@/services/api/CartItem/type";
import cartApi from "../../../services/api/Cart";
import cartItemApi from "../../../services/api/CartItem";
import { CURRENT_SUBDOMAIN, DEMANDORIA_SUBDOMAINS } from "@/utils/stringUtils";
import { TFunction } from "i18next";

export const handleRemoveCartItem = async (itemId: string, t: TFunction) => {
  const isSuitcase = CURRENT_SUBDOMAIN === DEMANDORIA_SUBDOMAINS[2];

  const confirmMessage = t(
      isSuitcase
          ? "shoppingCart.alerts.removeItem_suitcase"
          : "shoppingCart.alerts.removeItem_cart"
  );

  if (confirm(confirmMessage)) {
    try {
      await cartItemApi.deleteCartItem(itemId);
    } catch (error) {
      console.error("Error removing cart item", error);
    }
  }
};

export const handleClearCartClick = async (cartId: string, t: TFunction) => {
  if (confirm(t("shoppingCart.alerts.clearCart"))) {
    try {
      await cartApi.deleteCart(cartId);
    } catch (error) {
      console.warn("Error cleaning items from cart: ", error);
    }
  }
};

export const handleRemoveAllCartItems = async (items: ICartItem[], t: TFunction) => {
  if (confirm(t("shoppingCart.alerts.clearCart"))) {
    try {
      await Promise.all(
        items.map((item) => cartItemApi.deleteCartItem(item.id))
      );
    } catch (error) {
      console.error("Error removing cart item", error);
    }
  }
};
